import Page from "../../components/layout/Page";
import { Card, message } from 'antd';
import { useEffect, useState } from "react";
import "./index.scss";
import { getTrackingParams, reportEvent, reportGoogleConversion, reportScreen, setUserProperties, setUserProperty } from '../../services/analyticsService';
import { postRequest } from '../../services/requestService'
import FillEmail from "./Components/FillEmail";
import FillCode from './Components/FillCode';
import CompleteSignup from './Components/CompleteSignup'
import { useDispatch } from 'react-redux';
import { push } from "connected-react-router";
import { getCookie, getQueryParam, getRedirectUrl } from "../../services/clientService";
import { buildLoginPageUrl } from "../../services/urlBuilderService";
import { setAuthToken } from "../../services/authService";
import { setUserDetails } from "../../store/reducers/Auth/actions";
import Spinner from "../../components/forms/Spinner";
import { triggerApplicationModal } from "../../store/reducers/Modal/actions";

const LOADING_MESSAGES = [
    "Setting up your profile",
    "Analyzing your job",
    "Drafting your job-specific cover letter",
    "Generating an optimized Resume file"
];

const LoginPage = ({ flow }) => {
    const dispatch = useDispatch()
    const [email, setEmail] = useState('')
    const [step, setStep] = useState('email')
    const [loading, setLoading] = useState(false)
    const [code, setCode] = useState('')
    const [userParams, setUserParams] = useState({ firstName: "", lastName: "" })
    const [showFancyLoader, setShowFancyLoader] = useState(false)
    const [loadingMessageIndex, setLoadingMessageIndex] = useState(0)
    const [tempSavedJob, setTempSavedJob] = useState()
    useEffect(() => {
        reportScreen(flow === 'resume-builder' ? 'resume-builder-login' : 'login')
    }, []);

    useEffect(() => {
        if (!flow && !getCookie('x-access-token')) {
            const googleCode = getQueryParam('code');
            if (googleCode) {
                completeGoogleLogin(googleCode)
            }
        }
    }, []);

    useEffect(() => {
        let interval;
        if (showFancyLoader) {
            interval = setInterval(() => {
                setLoadingMessageIndex((prevIndex) =>
                    prevIndex === LOADING_MESSAGES.length - 1 ? 0 : prevIndex + 1
                );
            }, 8000);
        }
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [showFancyLoader]);

    const completeGoogleLogin = async (googleCode) => {
        try {
            setLoading(true)
            const jobId = getCookie('job_id');
            if (jobId) {
                setShowFancyLoader(true);
            }
            const formData = {
                strategy: 'google',
                googleCode,
                redirectUri: buildLoginPageUrl({ isAbsolute: true }),
                lang: getQueryParam('lang'),
                trackingParams: getTrackingParams(),
                jobId,
                resumeId: getCookie('resume_id')
            }
            const res = await postRequest('auth/provider-login', formData);
            const { isNewUser, userDetails } = res.data;
            dispatch(setUserDetails(userDetails))
            if (isNewUser) {
                reportEvent('auth', 'register_success', { kind: 'google' })
                reportEvent('auth', 'complete_signup', { kind: 'google' })
                setUserProperty(userDetails, 'signed_up', true)
            }
            if (getCookie('resume_id')) {
                // window.location.href = `${window.location.href}/resume-builder/${getCookie('resume_id')}/design?signup=success`
                dispatch(push(`/resume-builder/${getCookie('resume_id')}/design?signup=success`))
            }
            else {
                dispatch(push('/'))
            }

            setLoading(false)
            setShowFancyLoader(false);
        }
        catch (e) {
            setShowFancyLoader(false);
            dispatch(push('/auth'))
        }
    }


    const onRequestCode = async () => {
        setLoading(true)
        await postRequest('auth/email-login', {
            email, trackingParams: getTrackingParams(),
            jobId: getCookie('job_id'),
            lang: getQueryParam('lang')
        })
        setStep('code')
        setLoading(false)
        message.success('Check your email! We just sent you a 6 digit code')
    }
    const onCheckCode = async (submittedCode) => {
        if (submittedCode.length < 6) {
            return message.error('Please fill the six digits code')
        }
        setLoading(true)
        const res = await postRequest('auth/verify-email-code', { code: submittedCode, email, jobId: getCookie('job_id'), resumeId: getCookie('resume_id') })
        reportEvent('auth', res?.data?.isCodeValid ? 'valid_code' : 'invalid_code', { isNewUser: res?.data?.isNewUser })
        setUserProperties(res.data.userDetails)

        if (res?.data?.isNewUser) {
            reportEvent('auth', 'register_success', { kind: 'local' })
            setShowFancyLoader(true);
        }
        if (res.data.savedJob) {
            setTempSavedJob(res.data.savedJob)
        }
        if (res.data.isNewUser) {
            setStep('complete_signup')
        }
        else if (!res.data.isCodeValid) {
            message.error('Invalid code, please try again')
            setTimeout(() => {
                document.querySelector('.code-input input').focus()
            }, 100)
        }
        else if (res.data.savedJob) {
            reportEvent('auth', 'trigger_application_modal')
            dispatch(triggerApplicationModal({ savedJob: res.data.savedJob }))
        }
        else {
            window.location.href = "/"
        }
        setLoading(false)
        setCode("")

    }

    const onCompleteSignup = async () => {
        reportEvent('auth', 'complete_signup', { kind: 'local' })
        await postRequest('user/update', { ...userParams, flow: 'completeSignup' })
        if (getCookie('resume_id')) {
            dispatch(push(`/resume-builder/${getCookie('resume_id')}/design?signup=success`))

        }
        else {
            dispatch(push('/'))
        }

    }


    return (
        <Page className="login-page">

            <Card className="login-card">
                <div className="logo-wrapper">
                    <img src="/logos/logo-genie-blue.png" alt="Get In Genie Logo" />
                </div>
                {!loading ? <>
                    {step === 'email' && <FillEmail loading={loading} onContinue={onRequestCode} email={email} setEmail={setEmail} />}
                    {step === 'code' && <FillCode onRequestCode={onRequestCode} code={code} setCode={setCode} onCheckCode={onCheckCode} />}
                    {step === 'complete_signup' && <CompleteSignup email={email} onCompleteSignup={onCompleteSignup}
                        setUserParams={setUserParams} userParams={userParams}
                    />}
                </> : (
                    <div className="loading-container">
                        <Spinner />
                        {showFancyLoader && (
                            <div className="loading-message">
                                {LOADING_MESSAGES[loadingMessageIndex]}
                            </div>
                        )}
                    </div>
                )}

            </Card>
        </Page>
    );
}

export default LoginPage;